import * as z from 'zod';
import { DEPARTMENT_KEY_PATTERN } from '@/lib/department-scope';

export const departmentFormSchema = z.object({
  Title: z.string().min(1, { message: 'TITLE_REQUIRED' }),
  Key: z
    .string()
    .trim()
    .min(1, { message: 'DEPARTMENT_KEY_REQUIRED' })
    .regex(DEPARTMENT_KEY_PATTERN, { message: 'DEPARTMENT_KEY_INVALID_FORMAT' }),
  Description: z.string().optional(),
});

export type DepartmentFormValues = z.infer<typeof departmentFormSchema>;
